import { profileFormEvents } from "../../../profile/hooks/profileFormEvents";
import * as jstBroadcast from "../../native-modules/tare/jstBroadcast";

/**
 * Notifies both native (via JSTBroadcast) and RN (via profileFormEvents) that
 * profile data has changed. This triggers ProfileFragment.refreshProfileData()
 * on Android native and ProfileTabContainer refetch on RN.
 *
 * Call this after any operation that modifies profile data (e.g. saving resume
 * glow-up improvements, uploading a resume file).
 */
export function notifyProfileDataChanged(): void {
  void jstBroadcast.dispatch({
    eventType: "FormCompleted",
    formName: "profileForm",
    result: "completed",
  });
  profileFormEvents.emit("rnFormCompleted");
}
